import { JsonObject, JsonProperty } from 'json2typescript';

@JsonObject('UserCollectionAlbumCard')
export class UserCollectionAlbumCard {

  @JsonProperty('card_id', Number)
  cardId: number = 0;

  @JsonProperty('name', String)
  name: string = '';

  @JsonProperty('cards_count', Number)
  cardsCount: number = 0;
}
